import React from "react";
import { placeService } from "../jwt/_services/hotel/placeService";

export const placeProvider = {
    getOptions,
    getItem,
};

async function getOptions(customFilter) {
    try {
        const listItems = await placeService.getOptions( customFilter );
        listItems.data.sort((a, b) => a.title.localeCompare(b.title));
        return listItems.data.map((item) => {
            return (
                {
                    id: item.id,
                    value: item.code + '-' + item.title,
                    label: <label>{ item.code.toUpperCase() + ' - '  } <b>{ item.title }</b> </label>
                }
            )
        });
    } catch (error) {
        console.log(error.message)
    }
}

async function getItem(id) {
    try {
        const item = await placeService.getItem(id);

        return (
            {
                id: item.id,
                value: item.code,
                label: <div><label>{item.code}</label></div>
            }
        );
    } catch (error) {
        console.log(error.message)
    }
}